import job from '@/store/modules/dashboard/modules/job';
import jobs from '@/store/modules/dashboard/modules/jobs';
import matches from '@/store/modules/dashboard/modules/matches';
import appointments from '@/store/modules/dashboard/modules/appointments';
import pointsBalance from '@/store/modules/dashboard/modules/points-balance';
import reviews from '@/store/modules/dashboard/modules/reviews';
import workOrder from '@/store/modules/dashboard/modules/work-order';
import workOrders from '@/store/modules/dashboard/modules/work-orders';
import publicProfile from '@/store/modules/dashboard/modules/public-profile';
import publicProfiles from '@/store/modules/dashboard/modules/public-profiles';
import workOrderMatches from '@/store/modules/dashboard/modules/work-order-matches';

export default {
  namespaced: true,
  modules: {
    job,
    jobs,
    matches,
    appointments,
    pointsBalance,
    reviews,
    workOrder,
    workOrders,
    publicProfile,
    publicProfiles,
    workOrderMatches,
  },
};
